module.exports = {
    title: "Job Openings",
    viewSchedule: 'View Interview Schedule',
    tab: {
        details: 'Details',
        media: 'Attachments',
        response: 'Response',
        report: 'Report',
        candidates: {
            tab: {
                candidatesList: 'Candidate List',
                outSystemCandidatesList: 'Other Candidate List',
                CandidateInterviewScheduleList: 'Interviewed List (Rounds)',
            }
        }
    },
    crud: {
        recruitments_status: 'status',
        create: 'Job Opening Create',
        edit: 'Job Opening Edit',
        publish: 'Job Opening Publish',
    },
    button: {
        view_interviews: 'View Interviews',
    },
    form: {
        title : "Job Title",
    },
    validation: {
        required: {
            job_title: "Job title is required.",
            hire_for : "Hire for is required.",
            job_type : "Job type is required.",
            employment_type : "Employment type is required.",
            work_type : "Work type is required.",
            dates : "Tentative date is required.",
            no_of_opening : "No of Opening  is required.",
            description : "Description is required.",
            recent_skills : "Recent skill is required.",
            other_skills : "Other skill  is required.",
            education : "Education  is required.",
            experience : "Min Experience is required.",
            max_experience : "Max Experience is required.",
            currency : "Currency is required.",
            budget : "Min CTC is required.",
            max_budget : "Max CTC is required.",
            hire_based_on : "Hire based on is required.",
            owner_name : "Company name is required.",
            owner_contact : "Company contact is required.",
            owner_email : "Company email is required.",
            industry : "Industry is required.",
        },
    },
    table: {
        title: "title",
        registeredType: "Registered As",
        firstName: 'User Name',
        description: 'Description',
        noOfOpenings: 'No of openings',
        minSalary: 'Min.Salary',
        maxSalary: 'Max. Salary',
        added: 'Added at',
        updated: 'Updated at',
        experience: 'Experience',
        commissionType: "Commission Type",
        commission: "Commission",
        company: 'Company',
        jobtype: 'Type',
        commissionMonth: "Commission Month(s)",
        candidates: {
            firstName: 'First Name',
            lastName:  'Last Name',
            nickName:  'Nick Name',
            email:    'Email',
            company:  'Company',
            interview: {
                template: 'Template Title',
                round: 'Round',
                status: 'Status',
                remarks: 'Remarks',
                mode: 'Interview Mode',
                interviewDate: 'On Date',
                interviewTime : 'On time',
                createdAt: 'Created At',
                updatedAt: 'Updated At',
            }
        },

    },
    detail: {
        title: "Title",
        status: "Status",
        registeredType: "Registered As",
        firstName: 'User Name',
        description: 'Description',
        noOfOpenings: 'No of openings',
        minSalary: 'Min.Salary',
        maxSalary: 'Max. Salary',
        added: 'Added at',
        updated: 'Updated At',
        experience: 'Experience',
        commissionType: "Commission Type",
        commission: "Commission",
        commissionMonth: "Commission Month(s)",
        expiredDate: 'Expired at',
        company: 'Company',
        jobtype: 'Type',
        viewerType: ' Viewer Type',
        workType: 'Work Type',
        requirement: 'Requirement',
    },
    filter: {
        companyList: 'Companies',
        experience: 'Experience',
        commissionType: "Commission Type",
        jobType: 'Type',
        title: 'Title',
        workType: 'Work Type',
        requirement: 'Requirement',
        currency: 'Currency',
    },
}
